import React from "react";

// 年間テスト
const testingDate =[
    '',
    '9月27日(日)',
    '10月18日(日)',
    '11月23日(月祝)',
    '12月13日(日)',
    '1月17日(日)'
]

const ScheduleTable  = () => {
    return (
        <>
            <table className="table table-bordered"> 
            <tbody>    
                {testingDate.map((date, i) =>
                    <> 
                    {   i!==0 && 
                            <tr >
                                <td key={i}>第{i}回</td>
                                <td >{date}</td>
                            </tr>
                    }
                    </>
                )}
            </tbody>
            </table>
        </>
    );
}

export default ScheduleTable;